import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, ProjectsConstructorForm } from '@/components';
import { AddPositionDto, ProjectDto } from '@/core';
import { useSchemaRoles, FormValueType } from './hooks';
import classes from './RolesAndRatesForm.module.scss';

type PropsType = {
  initialValue: FormValueType;
  formUid: string;
  handleCancel?: () => void;
  handleSubmit: (positionData: AddPositionDto) => void;
  isCancelButton?: boolean;
  projectData: ProjectDto;
};

export const RolesAndRatesForm = ({
  initialValue,
  formUid,
  handleCancel,
  handleSubmit,
  isCancelButton,
  projectData,
}: PropsType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const schemaRoles = useSchemaRoles(projectData, initialValue);

  return (
    <ProjectsConstructorForm<FormValueType>
      handleCancel={handleCancel}
      handleSubmit={handleSubmit}
      schema={schemaRoles}
      initialValues={initialValue}
      formUid={formUid}
      isCancelButton={isCancelButton}
    >
      <div className={classes.roleInput}>
        <Form.Input
          label={false}
          name="name"
          allowClear
          required
          placeholder={t('addRoles.placeholder.name')}
        />
      </div>
      <div className={classes.rateInput}>
        <Form.Money
          label={false}
          name="rate"
          placeholder={t('addRoles.placeholder.rate')}
          required
          positive
          controls={false}
        />
      </div>
    </ProjectsConstructorForm>
  );
};
